import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TooltipDialogComponent } from "../avg-price-tooltip-cell-renderer/tooltip-dialog/tooltip-dialog.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-item-list-cell-renderer",
  templateUrl: "./item-list-cell-renderer.component.html",
  styleUrls: ["./item-list-cell-renderer.component.scss"],
})
export class ItemListCellRendererComponent implements OnDestroy {
  params;
  list: { label: string; price: number; type?: string;showIcon : boolean,isReceived:boolean }[];
  items: { label: string; number: number, }[];
  dialogRef
  private destroy$ = new Subject<void>();
  constructor(
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private dialog: MatDialog
  ) {}

  agInit(params: any): void {
    this.params = params;
    this.list = this.params["props"];
    this.items = this.list.map((item) => {
      let number;
      if (item.type === "currency") {
        number = this.currencyPipe.transform(item.price);
      } else if (item.type === "number") {
        number = this.decimalPipe.transform(item.price);
      } else {
        number = item.price;
      }
      return {
        label: item.label,
        number: number,
        showIcon: item.showIcon,
        type:item.type,
        isReceived:item.isReceived
      };
    });
  }
  openDialog(e: MouseEvent,type,data) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    this.dialogRef = this.dialog.open(TooltipDialogComponent, {
      hasBackdrop: false,
      position: {
        left: targetPosision.right + 10 + "px",
        top: targetPosision.top - 30 + "px",
      },
      data: {
        Type: type,
        tooltipData: data
      }
    });
  }
  closeDialog(e) {
    this.dialogRef.close();
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
